import { formatDistanceToNow } from 'date-fns';
import type { Update } from '../api/client';

interface RecentUpdatesProps {
  updates: Update[];
}

const sentimentEmoji: Record<string, string> = {
  positive: '🟢',
  neutral: '🟡',
  negative: '🔴',
};

export default function RecentUpdates({ updates }: RecentUpdatesProps) {
  const recentUpdates = updates.slice(0, 10);

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Recent Updates</h2>

      {recentUpdates.length === 0 ? (
        <p className="text-gray-500 text-sm">No updates yet</p>
      ) : (
        <div className="space-y-4">
          {recentUpdates.map((update) => (
            <div key={update.id} className="border-b border-gray-100 pb-4 last:border-0">
              <div className="flex items-start gap-3">
                <span className="text-lg">
                  {sentimentEmoji[update.sentiment || 'neutral']}
                </span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-gray-700 line-clamp-2">
                    {highlightHashtags(update.raw_text)}
                  </p>
                  <p className="text-xs text-gray-400 mt-1">
                    {formatDistanceToNow(new Date(update.created_at), { addSuffix: true })}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function highlightHashtags(text: string): React.ReactNode {
  const parts = text.split(/(#\w+[-\w]*)/g);
  return parts.map((part, i) =>
    part.startsWith('#') ? (
      <span key={i} className="text-primary-600 font-medium">{part}</span>
    ) : (
      part
    )
  );
}
